import React from 'react';
import { AvatarSocialProof } from './avatar/avatar-social-proof';
import { AudioSocialProof } from './audio-social-proof';
import { InstagramSocialProof } from './instagram/instagram-social-proof';
import { DraggableComponents } from '../../../../common/types/checkout';

type Props = {
  component: DraggableComponents;
};

export const SocialProofPreview: React.FC<Props> = ({ component }) => {
  switch (component?.configurations?.testimonial?.testimonialType) {
    case 'avatar':
      return <AvatarSocialProof component={component} />;
    case 'audio':
      return <AudioSocialProof component={component} />;
    case 'instagram':
      return <InstagramSocialProof component={component} />;
    default:
      return null;
  }
};
